import React, { Component } from "react";
import Classes from "./style.module.css";
import { GoSearch } from "react-icons/go";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";

export default class Thousandthree extends Component {
    constructor(props) {
        super(props);
        this.state = {
            defVal: [],
            value: [],
            isUpdating: false,
            selectallchecked: true,
            searchQuery: "", 
        };
        this.storeValue = this.storeValue.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.selectallclick = this.selectallclick.bind(this);
    }

    componentDidMount() {
        const getValues = (data) => (data.includes(",") ? data.split(",") : [data]);

        let value = getValues(this.props.filterData);
        let defVal = getValues(this.props.defdata);
        let selectAllChecked = value.every((val) => defVal.includes(val));

        this.setState({ defVal, value, selectallchecked: selectAllChecked, isUpdationDone: true });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filterData !== this.props.filterData || prevProps.defdata !== this.props.defdata) {
            const getValues = (data) => (data.includes(",") ? data.split(",") : [data]);

            let value = getValues(this.props.filterData);
            let defVal = getValues(this.props.defdata);
            let selectAllChecked = value.every((val) => defVal.includes(val));

            this.setState({ defVal, value, selectallchecked: selectAllChecked, isUpdationDone: true });
        }
    }

 storeValue(e) {
    const val = e?.target?.value;

    if (!val) return;

    let arr = [...this.state.defVal];

    if (e.target.checked) {
        
        if (!arr.includes(val)) {
            arr.push(val);
        }
    } else {
       
        arr = arr.filter(v => v !== val);
    }

    
    const allChecked =
        Array.isArray(this.state.value) &&
        this.state.value.length > 0 &&
        this.state.value.every(v => arr.includes(v));

    this.setState({
        defVal: arr,
        selectallchecked: allChecked,
    });

    
    const cleaned = arr.filter(v => v);

    this.props.onChange(cleaned.join(","), val);
}


    

    selectallclick(e) {
        let checked = e.target.checked;
        this.setState({ selectallchecked: checked, defVal: checked ? [...this.state.value] : [] });
        this.props.onChange(checked ? this.state.value.join(",") : "", e.target.value);
    }

    handleSearch(e) {
        this.setState({ searchQuery: e.target.value });
    }

    render() {
        const { searchQuery, isUpdationDone, value, defVal, selectallchecked } = this.state;

        const filteredValues = value.filter((val) => val.toLowerCase().includes(searchQuery.toLowerCase()));

        return (
            <>
                {isUpdationDone ? (
                    <div className="row" style={{ maxHeight: "370px" }}>
                        <div className="col-md-6">
                            <div style={{ padding: "10px 0" }}>
                            <div className="textsearch" style={{ width: "100%", position: "relative" }}>
                                <input
                                    className="textinp2"
                                    type="text"
                                    placeholder="Search..."
                                    value={searchQuery}
                                    onChange={this.handleSearch}
                                    autoFocus={true}
                                    // style={{ paddingRight: "30px" }} 
                                />
                                {/* {searchQuery && (
                                    <span
                                        onClick={this.clearSearch}
                                        style={{
                                            position: "absolute",
                                            right: "10px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "gray",
                                            fontSize: "18px"
                                        }}
                                    >
                                        ✖
                                    </span>
                                )} */}
                                  <GoSearch className="searchtextinp" />
                                 {/* { !searchQuery && <GoSearch className="searchtextinp" />} */}
                            </div>
                        
                            </div>
                        </div>

                        <div className="col-md-6" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                            <FormControl component="fieldset">
                                <FormGroup row>
                                    <FormControlLabel
                                        key="selectall"
                                        value="selectall"
                                        control={
                                            <Checkbox
                                                sx={{
                                                    color: "#29B6F6",
                                                    "&.Mui-checked": { color: "#29B6F6" },
                                                }}
                                                checked={selectallchecked}
                                                onChange={this.selectallclick}
                                            />
                                        }
                                        label="Select All"
                                        sx={{ display: "block", color: "gray" }}
                                    />
                                </FormGroup>
                            </FormControl>
                        </div>
                        <hr style={{ color: "grey" }} />

                        {filteredValues.length > 0 ? (
                            <div className={Classes.overflow} style={{ maxHeight: "300px", overflow: "auto" }}>
                                <FormControl component="fieldset" className="px-3">
                                    <FormGroup row>
                                        {filteredValues.map((val, index) => (
                                            <div className="col-md-6" key={index} style={{ display: "flex" }}>
                                                <FormControlLabel
                                                    key={val}
                                                    value={val}
                                                    control={
                                                        <Checkbox
                                                            sx={{
                                                                color: "#29B6F6",
                                                                "&.Mui-checked": { color: "#29B6F6" },
                                                            }}
                                                            checked={defVal.includes(val)}
                                                            onChange={this.storeValue}
                                                        />
                                                    }
                                                    label={val}
                                                    sx={{ display: "block", color: "gray" }}
                                                />
                                            </div>
                                        ))}
                                    </FormGroup>
                                </FormControl>
                            </div>
                        ) : (
                            <div className="col-md-12 text-center" style={{ color: "gray", padding: "10px" }}>
                                No results found
                            </div>
                        )}
                    </div>
                ) : (
                    "loading"
                )}
            </>
        );
    }
}
